(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cby-offspring-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest(
      '[data-offspring-filter]'
    );

    if (!filterButton) return;

    const section = filterButton.closest(
      '.offspring-overview'
    );

    const grid = section
      ? section.querySelector('.offspring-overview__grid')
      : null;

    if (!section || !grid) return;

    const selectedFilter =
      filterButton.dataset.offspringFilter;

    const filterButtons =
      section.querySelectorAll('[data-offspring-filter]');

    const cards =
      grid.querySelectorAll('.offspring-card');

    filterButtons.forEach((button) => {
      const isActive = button === filterButton;

      button.classList.toggle('is-active', isActive);

      button.setAttribute(
        'aria-pressed',
        isActive ? 'true' : 'false'
      );
    });

    cards.forEach((card) => {
      const isShowed =
        String(card.dataset.showed).toLowerCase() === 'true';

      if (selectedFilter === 'showed') {
        card.hidden = !isShowed;
      } else {
        card.hidden = false;
      }
    });
  });

  document.addEventListener('change', (event) => {
    const select =
      event.target.closest('[data-offspring-sort]');

    if (!select) return;

    const section =
      select.closest('.offspring-overview');

    const grid = section
      ? section.querySelector('.offspring-overview__grid')
      : null;

    if (!grid) return;

    const cards = Array.from(grid.children);

    const getText = (card, key) =>
      (card.dataset[key] || '').toLowerCase();

    const getNumber = (card, key) =>
      parseFloat(card.dataset[key]) || 0;

    const getFeatured = (card) =>
      card.dataset.featured === 'true' ? 0 : 1;

    const sorters = {
      featured: (a, b) =>
        getFeatured(a) - getFeatured(b),

      'name-asc': (a, b) =>
        getText(a, 'name').localeCompare(
          getText(b, 'name')
        ),

      'name-desc': (a, b) =>
        getText(b, 'name').localeCompare(
          getText(a, 'name')
        ),

      'year-desc': (a, b) =>
        getNumber(b, 'year') -
        getNumber(a, 'year'),

      'year-asc': (a, b) =>
        getNumber(a, 'year') -
        getNumber(b, 'year'),

      'sire-asc': (a, b) =>
        getText(a, 'sire').localeCompare(
          getText(b, 'sire')
        ),

      'lte-desc': (a, b) =>
        getNumber(b, 'lte') -
        getNumber(a, 'lte'),

      'lte-asc': (a, b) =>
        getNumber(a, 'lte') -
        getNumber(b, 'lte'),

      'breeder-asc': (a, b) =>
        getText(a, 'breeder').localeCompare(
          getText(b, 'breeder')
        ),

      'owner-asc': (a, b) =>
        getText(a, 'owner').localeCompare(
          getText(b, 'owner')
        ),

      'trainer-asc': (a, b) =>
        getText(a, 'trainer').localeCompare(
          getText(b, 'trainer')
        )
    };

    const sortFunction = sorters[select.value];

    if (!sortFunction) return;

    cards
      .sort(sortFunction)
      .forEach((card) => grid.appendChild(card));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
  

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
